<template>
  <div class="new-header header-mypage-toolbar container display-flex" style="z-index: 103;  align-items: flex-end">
    <div class="header-bar v-layout w100" style="align-items: flex-start;"
         v-if="$store.state.playerMode==='basic' && $store.state.basicPlayerVisibility">
      <div class="h-layout w100">
        <div class="back" />
<!--        <div class="profile" style="height: 20px" v-if="$store.state.memberInfo.profile_image_url !== ''" />-->
        <tool-tip class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.GREETING_1]" />
      </div>
      <div class="w100" style="min-height: 50px">
        <div class="h-layout align-items-center w100 mt-1">
          <div class="back" @click="goBack">
            <img src="/assets/new/ic_arrow_left.png" style="width: 24px;">
          </div>
          <div >
            <img class="profile" v-if="$store.state.memberInfo.profile_image_url != null" :src="$store.state.memberInfo.profile_image_url">
            <img class="profile" v-else src='/assets/new/member_default.png'>
          </div>
          <div class="ml-3 h-layout align-items-center justify-between" style="flex: 1">
            <div class="v-layout mr-2">
              <label class="lbl_default">{{ $store.state.memberInfo.member_name + ' !' }}</label>
              <label class="lbl_bold lbl_default6" style="letter-spacing: -1px; ">
                {{  m_getSummary(this) }}</label>
            </div>
            <UserStatusSelect class="mr-3" v-model="userStatus" />
          </div>
          <div class="ml-2 menu" @click="openHamburger">
            <img class="img_menu" src="/assets/new/ic_menu.png">
          </div>
        </div>
      </div>
    </div>
    <div class="header-bar v-layout w100" style="align-items: flex-start;" v-else>
      <div v-if="$store.state.headerTooltipType" class="h-layout w100">
        <div class="back" v-if="$store.state.headerIsShowBack" />
<!--        <div class="profile" style="height: 20px" v-if="$store.state.headerProfile !== ''" />-->
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.GREETING_2" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.GREETING_2]" />
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.GREETING_3" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.GREETING_3]" />
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.POINT" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.POINT]" />
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.GREETING_1" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.GREETING_1]" />
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.USABLE_POINT" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.USABLE_POINT]" />
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.MY_NOTE" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.MY_NOTE]" />
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.MY_TEXTBOOK" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.MY_TEXTBOOK]" />
        <tool-tip v-if="$store.state.headerTooltipType === $c.HEADER_TOOLTIP_TYPE.PLAYLIST" class="lbl_default6" :label="$c.HEADER_TOOLTIP_TEXT[$c.HEADER_TOOLTIP_TYPE.PLAYLIST]" />
      </div>
      <div class="w100" style="min-height: 50px">
        <div class="h-layout align-items-center w100 mt-1">
          <div class="back" v-show="$store.state.headerIsShowBack" @click="goBack">
            <img src="/assets/new/ic_arrow_left.png" style="width: 24px;">
          </div>
          <div  >
            <img class="profile" v-if="$store.state.memberInfo.profile_image_url != null" :src="$store.state.memberInfo.profile_image_url">
<!--            <img v-if="$store.state.headerProfile != null" :src="$store.state.headerProfile">-->
            <img class="profile" v-else src='/assets/new/member_default.png'>
          </div>
          <div class="ml-3 h-layout align-items-center justify-between" style="flex: 1"  v-if="isLogin">
            <div class="v-layout mr-2">
              <label :class="[$store.state.headerSecondaryTitle ? 'lbl_default' : 'lbl_default7_3']"   style="white-space: pre-wrap;" v-if="$store.state.headerMainTitle !== ''">{{ $store.state.headerMainTitle }}</label>
              <label class="lbl_bold lbl_default6" style="letter-spacing: -1px;"
                     v-if="$store.state.headerSecondaryTitle !== ''">{{ $store.state.headerSecondaryTitle }}</label>
            </div>
            <UserStatusSelect class="mr-3" v-if="$store.state.headerIsShowOnlineStatus" v-model="userStatus" />
          </div>
          <div v-else  style="flex: 1" >

          </div>
          <div class="ml-2 menu" v-show="$store.state.headerIsShowMenu" @click="openHamburger">
            <img class="img_menu" src="/assets/new/ic_menu.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserStatusSelect from "@/components/UserStatusSelect";
import ToolTip from "@/components/ToolTip";
import  * as ajax from "@/utils/ajax.js";
import * as biz from './../../utils/biz.js'
import * as utils from "@/utils/utils.js";
import {getSummary} from "../../utils/utils";
const u = require('util')

export default {
  name: "NewHeader",
  components: {ToolTip, UserStatusSelect},
  props: {
    onBack: Function,
  },
  data() {
    return {
      u: u,
      userStatus: this.$store.state.onlineStatus,
      isLogin:false,
    }
  },
  methods: {
    m_getSummary(ref){
      getSummary(ref)
    },
    goBack(){
      console.log("------------inside new header: goBack()----------")
      if (this.onBack){
        console.log("------------inside new header: goBack()-> hidden----------")
        this.onBack();
      }else{
        console.log("------------inside new header: goBack()-> route back----------")
        this.$router.back();
      }
    },
    closeEvent() {
      this.$emit("closeEvent");
    },
    openHamburger() {
      this.$store.state.enableHamburgerMenu = true
      document.querySelector('ion-menu-controller').open();
    }
  },
  mounted() {
    this.isLogin = biz.isLogin(this);
    if (this.$cookie.get("accessToken")){
      ajax.Get(this, '/api/member/member/', (ref,data)=>{
        if (data !== null || data !== "") {
          if (data.nickname === null || data.nickname === "")
            data.nickname = data.member_name;

          if (data.member_kind === "20") {
            ref.isfree = false;
          }
        }
        ref.$store.state.memberInfo = data;
        ref.$store.state.headerSecondaryTitle =  getSummary(this);
        ref.$store.state.headerMainTitle =  data.member_name + ' !';
        ref.$store.state.headerProfile = data.profile_image_url;
        ref.$store.state.headerTooltipType = ref.$c.HEADER_TOOLTIP_TYPE.GREETING_1;
        ref.$store.state.onlineStatus = data.online_status;
        ref.userStatus = data.online_status;

        ref.memberKind = data.member_kind;
      });
    }
  },
  watch: {
    userStatus: function (new_val, old_val) {
      ajax.Post(this, "/api/member/member/change_online_status", {status: new_val}, function (ref, data) {
        ref.$store.state.onlineStatus = new_val;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.new-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 105;
}
.select-wrapper {
  padding: 10px;
  border-radius: 10px;
  background-color: white;
}

.header-bar {
  display: flex;
  align-items: center;
  padding-bottom: 25px;

  .menu {
    margin-right: 10px;
    display: flex;

    .img_menu {
      width: 22px;
      height: 13px;
    }
  }

  .profile {
    width: 32px;
    height: 32px;
      border-radius: 50%;
  }
}
</style>
